class FilterPromo extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.handleClose = this.handleClose.bind(this)

    if (this.els.close?.exists) {
      this.listeners.add(this.els.close.element, 'click', this.handleClose)
    }
  }

  handleClose () {
    window.BAO.Cart.updateCartAttributes({
      [this.dataset.cartAttribute]: 'closed',
    })

    this.classList.add(this.closingClass)

    window.setTimeout(() => {
      this.remove()
    }, 2000)
  }

  get closingClass () {
    return `clc-FiltersPromo-closing`
  }
}

if (!customElements.get('filter-promo')) {
  customElements.define('filter-promo', FilterPromo)
}
